// extracted by mini-css-extract-plugin
export default {"colorDetails":"ColorDetails_colorDetails__EnEZ3"};